import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, Table } from "antd";
import { formateDate } from "../../utils/dateUtil";
class ConfigHistoryModal extends Component {
  state = {
    loading: false,
    item: null,
    items: [],
  };

  static propTypes = {
    logs: PropTypes.array.isRequired,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
    console.log();
  }
  // 遠端數據處理 //////////////////////////////////////////////

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "作業項目",
        dataIndex: "behaviorName",
        width: 30,
      },
      {
        title: "作業內容",
        dataIndex: "isLockedName",
        width: 30,
      },
      {
        title: "作業人員",
        dataIndex: "recordModifyUserName",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "作業時間",
        dataIndex: "recordModifyDateTime",
        width: 20,
        render: (recordModifyDateTime) => formateDate(recordModifyDateTime),
      },
    ];
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { loading } = this.state;
    const { logs } = this.props;
    // console.log(logs)
    return (
      <Card>
        <Table
          dataSource={logs}
          columns={this.columns}
          loading={loading}
          rowKey="Uid"
          scroll={{ y: 460 }}
          width="60%"
          pagination={false}
        />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(ConfigHistoryModal);
